export const ajusteDiferencialRedondeo = (valor, decimales) => {
    if (decimales?.length === 0) return [];

    decimales.forEach((dec, index) => {
        decimales[index] = redondear(dec);
    });

    let ultimoIndex = decimales.length - 1;

    const diferencia = redondear(
        valor -
        redondear(
            decimales.reduce(
                (acc, dec) => acc + dec,
                0
            ),
            2
        ),
        2
    );

    decimales[ultimoIndex] = redondear( decimales[ultimoIndex] + diferencia,2);
    return decimales;
};

export const ajusteDiferencialRedondeoJson = (valor, decimales, field) => {
    if (!field) return [];
    if (decimales?.length === 0) return [];

    decimales.forEach((dec, index) => {
        decimales[index][field] =
            redondear(dec[field]);
    });

    let ultimoIndex = decimales.length - 1;

    const diferencia = redondear(valor - redondear(decimales.reduce((acc, dec) => acc + dec[field], 0), 2), 2);

    decimales[ultimoIndex][field] =
        redondear(
            decimales[ultimoIndex][field] +
            diferencia,
            2
        );

    return decimales;
};

// FUNCION QUE REDONDEA UN NUMERO A UNA CANTIDAD DE DECIMALES DETERMINADA
export const redondear = (numero, decimales = 2) => {
    return numero?.toFixed
        ? parseFloat(
            numero.toFixed(decimales)
        )
        : 0;
};

export const ajusteRedondeoEquitativoJson = (jsonArray, fields) => {

    let arrayData = [...jsonArray];

    fields.forEach(field => {

        if (
            !Array.isArray(arrayData) ||
            !arrayData.length === 0 ||
            !field
        ) {
            return [];
        }

        // 1. Suma original del campo
        const sumaOriginal =
            arrayData.reduce(
                (sum, obj) =>
                    sum + (obj[field] || 0),
                0
            );

        const sumaObjetivo =
            Math.round(
                sumaOriginal * 100
            ) / 100;


        // 2. Redondear cada detalle
        const valoresRedondeados =
            arrayData.map(
                obj =>
                    Math.round(
                        (obj[field] || 0) *
                        100
                    ) / 100
            );


        // 3. Suma después del redondeo
        const sumaRedondeada =
            valoresRedondeados.reduce(
                (sum, num) =>
                    sum + num,
                0
            );


        // 4. Diferencia
        let diferencia =
            Math.round(
                (
                    sumaObjetivo -
                    sumaRedondeada
                ) * 100
            ) / 100;


        let resultado =
            arrayData.map(
                (obj, i) => ({
                    ...obj,
                    [field]:
                        valoresRedondeados[i]
                })
            );


        // 5. Repartir diferencia
        if (diferencia !== 0) {

            const perdidas =
                arrayData.map(
                    (obj, index) => {

                        const original =
                            obj[field] || 0;

                        return {
                            index,
                            original,
                            redondeado:
                                valoresRedondeados[
                                    index
                                ],
                            perdida:
                                original -
                                valoresRedondeados[
                                    index
                                ]
                        };
                    }
                );


            let elementosOrdenados;

            if (diferencia > 0) {

                elementosOrdenados =
                    perdidas.sort(
                        (a, b) =>
                            b.perdida -
                            a.perdida
                    );

            } else {

                elementosOrdenados =
                    perdidas.sort(
                        (a, b) =>
                            a.perdida -
                            b.perdida
                    );
            }


            const ajustePorElemento =
                diferencia > 0
                    ? 0.01
                    : -0.01;


            const elementosAjustar =
                Math.abs(
                    Math.round(
                        diferencia * 100
                    )
                );


            for (
                let i = 0;
                i < elementosAjustar &&
                i < elementosOrdenados.length;
                i++
            ) {

                const indiceAjustar =
                    elementosOrdenados[i]
                        .index;


                resultado[
                    indiceAjustar
                ][field] =
                    Math.round(
                        (
                            resultado[
                                indiceAjustar
                            ][field] +
                            ajustePorElemento
                        ) * 100
                    ) / 100;


                resultado[
                    indiceAjustar
                ].AjusteRedondeo = true;


                resultado[
                    indiceAjustar
                ].AjusteRedondeoDiff =
                    resultado[
                        indiceAjustar
                    ][field] -
                    valoresRedondeados[
                        indiceAjustar
                    ];


                resultado[
                    indiceAjustar
                ].valorOriginal =
                    resultado[
                        indiceAjustar
                    ][field];
            }
        }

        arrayData = resultado;
    });

    return arrayData;
};